import { useCallback } from 'react'
import { ModalSize, PrescricaoType } from '_metronic/helpers'
import { useModal } from 'app/components'
import { CustomOption } from '../../core/_model'
import { catalogoDaOpcao, opcaoDoCatalogo } from '../../core/montagem/catalogo'
import { CategoriaItem, ItemCatalogo } from '../../core/montagem/itens'
import { ExameModal } from '../modal/ExameModal'
import { FormulaModal } from '../modal/FormulaModal'
import { MedicamentoModal } from '../modal/MedicamentoModal'
import { OrientacaoModal } from '../modal/OrientacaoModal'
import { useRotulos } from '../comum/useRotulos'

const CHAVE: Record<CategoriaItem, string> = {
  [PrescricaoType.Medicamento]: 'medicamento',
  [PrescricaoType.Formula]: 'formula',
  [PrescricaoType.Exame]: 'exame',
  [PrescricaoType.Orientacoes]: 'orientacao',
}

/**
 * Abre os modais de cadastro já existentes: sem `anterior`, cadastra um item fora do catálogo
 * (o backend grava junto com a prescrição); com `anterior`, edita o cadastro do próprio médico.
 */
export const useCadastroItem = () => {
  const { showModal } = useModal()
  const { t } = useRotulos()

  return useCallback(
    (
      categoria: CategoriaItem,
      onConfirm: (catalogo: ItemCatalogo) => void,
      anterior?: ItemCatalogo
    ) => {
      const opcao = anterior ? opcaoDoCatalogo(anterior) : undefined
      const confirmar = (resultado: CustomOption) => {
        if (resultado) onConfirm(catalogoDaOpcao(resultado, categoria, anterior))
      }
      const conteudo = {
        [PrescricaoType.Medicamento]: <MedicamentoModal item={opcao} onConfirm={confirmar} />,
        [PrescricaoType.Formula]: <FormulaModal item={opcao} onConfirm={confirmar} />,
        [PrescricaoType.Exame]: <ExameModal item={opcao} onConfirm={confirmar} />,
        [PrescricaoType.Orientacoes]: (
          <OrientacaoModal
            titulo={opcao?.label}
            orientacoes={opcao?.descricao}
            onConfirm={confirmar}
          />
        ),
      }[categoria]

      showModal({
        title: t(`prescricao.cadastro.${anterior ? 'editar' : 'novo'}.${CHAVE[categoria]}`),
        content: conteudo,
        size: categoria === PrescricaoType.Medicamento ? ModalSize.Large : ModalSize.Medium,
      })
    },
    [showModal, t]
  )
}
